// src/redux/searchFiltersSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
  statusNames: [],   // eg: ["Open", "Closed"]
  statusValues: [],  // eg: ["OPEN", "CLOSED"]
  startDate: "",
  endDate: "",
  activeTabJobsPage: "All Jobs",
};

const searchFiltersSlice = createSlice({
  name: "searchFilters",
  initialState,
  reducers: {
    setSearchFilters(state, action) {
      const {
        searchTerm = "",
        statusNames = [],
        statusValues = [],
        startDate = "",
        endDate = "",
        activeTabJobsPage = "All Jobs",
      } = action.payload || {};
      state.searchTerm = searchTerm;
      state.statusNames = statusNames;
      state.statusValues = statusValues;
      state.startDate = startDate;
      state.endDate = endDate;
      state.activeTabJobsPage = activeTabJobsPage;
    },
    clearSearchFilters(state) {
      state.searchTerm = "";
      state.statusNames = [];
      state.statusValues = [];
      state.startDate = "";
      state.endDate = "";
    },
  },
});

export const { setSearchFilters, clearSearchFilters } = searchFiltersSlice.actions;
export default searchFiltersSlice.reducer;
